import React from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

interface ProgressGaugeProps {
  value: number; // 0-100
  maxValue?: number;
  title?: string;
  subtitle?: string;
  size?: number;
  color?: string;
  backgroundColor?: string;
  showPercentage?: boolean;
  thickness?: number;
}

const ProgressGauge: React.FC<ProgressGaugeProps> = ({
  value,
  maxValue = 100,
  title,
  subtitle,
  size = 120,
  color = '#2563eb',
  backgroundColor = '#e5e7eb',
  showPercentage = true,
  thickness = 8
}) => {
  const percentage = Math.min(Math.max((value / maxValue) * 100, 0), 100);
  const remaining = 100 - percentage;

  const data = {
    datasets: [
      {
        data: [percentage, remaining],
        backgroundColor: [color, backgroundColor],
        borderWidth: 0,
        cutout: `${size - thickness}px`,
        circumference: 360,
        rotation: -90,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
    elements: {
      arc: {
        borderRadius: 4,
      },
    },
  };

  return (
    <div className="flex flex-col items-center justify-center" style={{ width: size, height: size }}>
      <div className="relative">
        <Doughnut data={data} options={options} />
        {showPercentage && (
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <div className="text-2xl font-bold text-gray-900">
              {Math.round(percentage)}%
            </div>
            {subtitle && (
              <div className="text-xs text-gray-500 mt-1">
                {subtitle}
              </div>
            )}
          </div>
        )}
      </div>
      {title && (
        <div className="text-sm font-medium text-gray-700 mt-2 text-center">
          {title}
        </div>
      )}
    </div>
  );
};

export default ProgressGauge;